import React, { useEffect } from 'react';
import Hero from './Hero';
import BookingWalkthrough from './BookingWalkthrough';
import Gallery from './Gallery';
import Testimonials from './Testimonials';
import FAQ from './FAQ';
import Footer from './Footer';

const Home = () => {
  // Meta Pixel ViewContent tracking for Homepage
  useEffect(() => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'ViewContent', {
        content_type: 'product',
        content_name: 'Homepage - Pro-Wash Mobile Detailing',
        content_category: 'Mobile Car Detailing',
        value: 299,
        currency: 'CAD'
      });
    }
  }, []);

  return (
    <div>
      <Hero />
      <BookingWalkthrough />
      <Gallery />
      <Testimonials />
      <FAQ />
      <Footer />
    </div>
  );
};

export default Home;
